// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';
import { type ColombianDocumentType } from '../types';

export function validateColombianDocumentType(documentType: ColombianDocumentType): ?UserInputValidationError {
  const validDocuments = ['NIT', 'CC', 'CE'];
  if (!validDocuments.includes(documentType))
    return { id: 'invalid-colombian-document-type' };
}
